import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";

export default function AlertModal(props) {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const navigate = useNavigate();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    // border: '2px solid #000',
    // boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const handleClose = () => {
    props.setOpen(false);
  };
  console.log("props?.val", props?.val, "props.navigate", props.navigate)

  return (
    <div>
      <Modal
        open={props.open || props.UpdateOpen}
        onClose={props.handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          className="d-flex flex-column justify-content-between align-items-center"
          sx={{ ...style, width: 400, height: 180, borderRadius: 6 }}
        >
          <h4 className="text-center pt-3">
            {/* UpdateOpen={UpdateOpen} */}
            {/* {console.log('props.open',props.UpdateOpen)} */}
            {props.UpdateOpen ? props.UpdateOpen : props.open}
          </h4>
          <button
            className="modalSubmitBtn mb-3 fs-5"
            onClick={() => {
              props.UpdateOpen
                ? props.setUpdateOpen(false)
                : props.setOpen(false);
              //   props.handleClose()
              // props?.reset()
              // window.location.reload()
              navigate(props?.navigate);

             
            }}
          >
            OK
          </button>
        </Box>
      </Modal>

    </div>
  );
}
